import React from 'react';

const wrapStyle = {
  padding: '24px',
  maxWidth: 640,
  margin: '0 auto',
  fontFamily: 'system-ui, -apple-system, sans-serif',
  color: '#1a1a1a',
  lineHeight: 1.5,
};

const noteStyle = {
  background: '#f5f5f7',
  padding: '12px 16px',
  borderRadius: 8,
  margin: '12px 0',
  fontSize: 14,
};

const codeStyle = {
  background: '#f0f0f0',
  padding: '2px 6px',
  borderRadius: 4,
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
  fontSize: 13,
};

function WidgetAccessDenied({ parentInfo }) {
  const detected = parentInfo?.origin || parentInfo?.url || '';

  return (
    <div style={wrapStyle}>
      <h3 style={{ marginTop: 0 }}>BoardWatch widget not authorized for this site</h3>
      <p>This district&rsquo;s widget can only load on approved domains.</p>

      <div style={noteStyle}>
        <strong>Using a site editor (Wix, Squarespace, GoDaddy, etc.)?</strong>
        <br />
        The widget activates on your <em>published</em> site. Save and publish your changes,
        then visit your live URL to verify.
      </div>

      <div style={noteStyle}>
        <strong>Already on your published site?</strong>
        <br />
        Contact BoardWatch to add your domain to the allowlist.
      </div>

      {detected && (
        <p style={{ marginTop: 16, fontSize: 13, color: '#666' }}>
          Detected origin: <span style={codeStyle}>{detected}</span>
        </p>
      )}
    </div>
  );
}

export default WidgetAccessDenied;
